<template>
  <field :label="label">
    <div class="control is-expanded width-100">
      <div :class="error ? 'select is-danger width-100' : 'select width-100'">
        <select  @input="onInput" @keyup="onKeyup" @blur="onBlur" @focus="onFocus" @change="onChange" class="width-100">
          <option value="">Select Job Board</option>
          <option v-for="option in options" :key="option.id" :value="option[valueKey]">
            {{ option.name }}
          </option>
        </select>
      </div>
    </div>
  <p class="help is-danger" v-if="error">{{ error }}</p>
  </field>
</template>

<script>
import Field from '@/components/general/field'
export default {
  components: {
    Field
  },
  props: ['error', 'options', 'defaultOption', 'label', 'valueKey'],
  methods: {
    onInput (event) {
      this.$emit('input', event.target.value)
    },
    onKeyup (event) {
      this.$emit('keyup', event)
    },
    onBlur (event) {
      this.$emit('blur', event)
    },
    onFocus (event) {
      this.$emit('focus', event)
    },
    onChange (event) {
      this.$emit('change', event.target.value)
    }
  }
}
</script>

<style scoped>
.width-100  {
  width:100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/general/select-field.vue